import { render, staticRenderFns } from "./ObsMedia.vue?vue&type=template&id=8e0f95e2&"
import script from "./ObsMedia.vue?vue&type=script&lang=js&"
export * from "./ObsMedia.vue?vue&type=script&lang=js&"
import style0 from "./ObsMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports